import { Theme } from '@mui/material/styles';

export default function Tabs(_: Theme): Theme['components'] {
  return {
    MuiTabs: {},
    MuiTab: {},
  };
}
